import React, { useState, useEffect } from 'react'

export default function MottoSection() {
    const [mottos, setMottos] = useState([])
    const [index, setIndex] = useState(0)

    useEffect(() => {
        fetch('/mottos.json')
            .then(res => res.json())
            .then(data => {
                setMottos(data)
                setIndex(Math.floor(Math.random() * data.length))
            })
            .catch(err => console.error('Failed to load mottos:', err))
    }, [])

    const shuffleMotto = () => {
        if (mottos.length === 0) return
        let newIndex
        do {
            newIndex = Math.floor(Math.random() * mottos.length)
        } while (newIndex === index)
        setIndex(newIndex)
    }

    if (mottos.length === 0) return null

    return (
        <div className='container'>
            <section className='motto-section' onClick={shuffleMotto} style={{ cursor: 'pointer' }}>
                <div className='motto-text' style={{ marginBottom: '3rem' }}>
                    {mottos[index].motto}
                </div>
                <div className='motto-signature'>
                    {mottos[index].signature}
                </div>
            </section>
        </div>
    )
}
